import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { Observable, of } from 'rxjs';
import { IMetricCode } from '@common/models/IMetricCode';
import { LocalStorageKey } from '../enums/local-storage-key.enum';

@Injectable({
    providedIn: 'root'
})
export class MetricCodesService {
    constructor(private readonly apiService: ApiService) {}

    public getAll(): Observable<IMetricCode[]> {
        return this.apiService.get('MetricCode');
    }

    public getMetricCode<T extends IMetricCode>(metricCode: string): Observable<T | undefined> {
        const raw = localStorage.getItem(LocalStorageKey.metricCodeCache);
        const metricCodeData: T[] = raw ? JSON.parse(raw) : [];
        return of(metricCodeData.find(prop => prop.metricCode === metricCode));
    }
}
